module.exports = __webpack_public_path__ + "img/icon-tax.2d337b82.png";